// extracted by mini-css-extract-plugin
export var container = "feature-module--container--OteY-";
export var image = "feature-module--image--1arGe";
export var text = "feature-module--text--tTBf2";
export var title = "feature-module--title--qdI4t";